import type { S3File, UploadCertificateFormData } from "@dune/types";
import { zodResolver } from "@hookform/resolvers/zod";
import { useForm } from "react-hook-form";
import { z } from "zod";

const uploadCertificateSchema = z.object({
	validityStartDate: z
		.string()
		.min(1, "La date de début de validité est requise"),
	validityEndDate: z.string().min(1, "La date de fin de validité est requise"),
	activities: z
		.string()
		.optional()
		.refine((val) => val && val.length > 0, {
			message: "Les activités sont requises",
		}),
	insurerSiren: z
		.string()
		.optional()
		.refine((val) => val && val.length > 0, {
			message: "Le SIREN de l'assureur est requis",
		}),
	selectedFile: z
		.any()
		.optional()
		.refine((file) => file !== undefined && file !== null, {
			message: "Un fichier doit être sélectionné",
		}),
});

export function useUploadCertificate() {
	const form = useForm<UploadCertificateFormData>({
		resolver: zodResolver(uploadCertificateSchema),
		defaultValues: {
			validityStartDate: "",
			validityEndDate: "",
			activities: "",
			insurerSiren: "",
			selectedFile: undefined,
		},
		mode: "onChange",
	});

	const resetForm = () => {
		form.reset({
			validityStartDate: "",
			validityEndDate: "",
			activities: "",
			insurerSiren: "",
			selectedFile: undefined,
		});
	};

	const setSelectedFile = (file: S3File | null) => {
		form.setValue("selectedFile", file, {
			shouldValidate: true,
			shouldDirty: true,
		});
	};

	return {
		...form,
		resetForm,
		setSelectedFile,
	};
}
